import {
  Action,
  ActionFields,
  ActionStatus,
} from '@tribeplatform/gql-client/global-types'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import { MutationDeleteEventArgs } from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getQueriesContainingEvent } from './utils.js'

export const useDeleteEvent = (options?: {
  fields?: ActionFields
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeleteEventArgs
  >
}) => {
  const { useMutationOptions, fields } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationDeleteEventArgs>(
    (input: MutationDeleteEventArgs) => client.events.delete(input, fields),
    {
      ...useMutationOptions,
      onSuccess: (updatedEvent, variables) => {
        if (updatedEvent.status !== ActionStatus.succeeded) {
          return
        }
        const eventQueries = getQueriesContainingEvent(
          queryClient,
          variables.eventId,
        )

        // eslint-disable-next-line no-restricted-syntax
        for (const query of eventQueries) {
          const hasEvent = query.state.data?.pages
            .flatMap(page => page.nodes)
            .some(node => node.id === variables.eventId)

          if (hasEvent) {
            query.setState({
              data: {
                ...query.state.data,
                pages: query.state.data.pages.map(page => ({
                  ...page,
                  nodes: page.nodes.filter(
                    node => node.id !== variables.eventId,
                  ),
                  edges: page?.edges?.filter(
                    edge => edge.node.id !== variables.eventId,
                  ),
                })),
              },
            })
          }
        }
      },
    },
  )
}
